var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoFilterScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 146,
    viewBox: "0 0 236 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.709 145.759C152.864 145.759 181.363 140.743 181.363 134.555C181.363 128.366 152.864 123.35 117.709 123.35C82.5536 123.35 54.0547 128.366 54.0547 134.555C54.0547 140.743 82.5536 145.759 117.709 145.759Z",
    fill: "url(#paint0_linear_265_20130)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.709 145.759C152.864 145.759 181.363 140.743 181.363 134.555C181.363 128.366 152.864 123.35 117.709 123.35C82.5536 123.35 54.0547 128.366 54.0547 134.555C54.0547 140.743 82.5536 145.759 117.709 145.759Z",
    fill: "#0F1048"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_265_20130",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 123,
    width: 128,
    height: 23
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.709 145.801C152.864 145.801 181.363 140.785 181.363 134.597C181.363 128.408 152.864 123.392 117.709 123.392C82.5536 123.392 54.0547 128.408 54.0547 134.597C54.0547 140.785 82.5536 145.801 117.709 145.801Z",
    fill: "#6C6CFF"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_265_20130)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6831 148.195C100.982 145.596 101.307 145.596 100.982 144.297C100.657 142.998 99.0336 140.725 99.6831 138.776C100.333 136.828 101.957 135.756 102.606 134.23C103.256 132.703 102.606 129.163 102.606 129.163L126.314 128.384L129.886 129.683C129.886 129.683 129.886 134.554 130.536 136.503C131.185 138.452 133.459 141.05 133.459 143.323C133.459 145.596 131.185 147.22 131.51 148.844C131.835 150.468 98.3841 150.793 99.6831 148.195Z",
    fill: "#6C6CFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_265_20130",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 128,
    width: 35,
    height: 23
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6831 148.195C100.982 145.596 101.307 145.596 100.982 144.297C100.657 142.998 99.0336 140.725 99.6831 138.776C100.333 136.828 101.957 135.756 102.606 134.23C103.256 132.703 102.606 129.163 102.606 129.163L126.314 128.384L129.886 129.683C129.886 129.683 129.886 134.554 130.536 136.503C131.185 138.452 133.459 141.05 133.459 143.323C133.459 145.596 131.185 147.22 131.51 148.844C131.835 150.468 98.3841 150.793 99.6831 148.195Z",
    fill: "#6C6CFF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_265_20130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.727 133.58C110.727 133.58 104.881 137.802 105.856 141.05C106.83 144.297 109.428 146.571 107.479 148.844",
    stroke: "white",
    strokeWidth: 0.974298,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.767 134.555C121.767 134.555 123.716 140.076 122.742 143.973C122.32 145.662 121.54 147.058 120.891 148.422",
    stroke: "white",
    strokeWidth: 0.974298,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.486 139.751C132.486 139.751 121.769 143.323 99.0352 136.828",
    stroke: "white",
    strokeWidth: 0.974298,
    strokeMiterlimit: 10
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8497 138.874L83.6427 138.192C83.7726 138.159 83.7726 137.965 83.6427 137.932L80.8497 137.25C80.8173 137.25 80.7523 137.218 80.7523 137.153L80.0703 134.36C80.0378 134.23 79.843 134.23 79.8105 134.36L79.1285 137.153C79.1285 137.185 79.096 137.25 79.031 137.25L76.2381 137.932C76.1081 137.965 76.1081 138.159 76.2381 138.192L79.031 138.874C79.0635 138.874 79.1285 138.906 79.1285 138.971L79.8105 141.764C79.843 141.894 80.0378 141.894 80.0703 141.764L80.7523 138.971C80.7848 138.939 80.8173 138.906 80.8497 138.874Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2389 134.912L92.9277 134.522C92.9926 134.49 92.9926 134.392 92.9277 134.36L91.2389 133.97C91.2064 133.97 91.174 133.937 91.174 133.905L90.7842 132.216C90.7518 132.151 90.6543 132.151 90.6219 132.216L90.2321 133.905C90.2321 133.937 90.1997 133.97 90.1672 133.97L88.4784 134.36C88.4134 134.392 88.4134 134.49 88.4784 134.522L90.1672 134.912C90.1997 134.912 90.2321 134.944 90.2321 134.977L90.6219 136.665C90.6543 136.73 90.7518 136.73 90.7842 136.665L91.174 134.977C91.2064 134.944 91.2389 134.912 91.2389 134.912Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M146.679 139.069L149.634 138.355C149.764 138.322 149.764 138.127 149.634 138.095L146.679 137.38C146.614 137.38 146.581 137.315 146.581 137.283L145.867 134.327C145.834 134.198 145.639 134.198 145.607 134.327L144.892 137.283C144.892 137.348 144.827 137.38 144.795 137.38L141.84 138.095C141.71 138.127 141.71 138.322 141.84 138.355L144.795 139.069C144.86 139.069 144.892 139.134 144.892 139.166L145.607 142.122C145.639 142.252 145.834 142.252 145.867 142.122L146.581 139.166C146.614 139.101 146.646 139.069 146.679 139.069Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.391 116.368C104.391 116.368 102.767 112.601 103.904 111.626C105.041 110.684 106.924 108.606 114.264 108.671C121.604 108.736 127.255 109.613 128.489 110.165C129.723 110.684 132.646 111.659 130.372 114.419C128.099 117.18 116.083 117.505 115.758 117.505C115.433 117.505 104.391 116.368 104.391 116.368Z",
    fill: "#0F1048"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M117.385 116.368C125.008 116.368 131.187 114.623 131.187 112.47C131.187 110.318 125.008 108.573 117.385 108.573C109.762 108.573 103.582 110.318 103.582 112.47C103.582 114.623 109.762 116.368 117.385 116.368Z",
    stroke: "#6C6CFF",
    strokeWidth: 0.974298,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M104.719 131.469C104.719 131.469 108.291 134.392 113.163 135.366C118.034 136.341 130.7 136.665 130.7 136.665L129.726 129.845L115.111 131.144L104.719 131.469Z",
    fill: "#0F1048"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M113.16 62.424C113.16 62.424 117.674 69.9586 119.85 71.1602C122.026 72.3943 124.917 66.4836 124.917 66.4836C124.917 66.4836 120.045 57.8773 119.331 57.3252",
    fill: "url(#paint1_linear_265_20130)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M120.341 56.3835C120.341 56.3835 121.51 64.4377 124.335 66.9709C124.335 66.9709 128.427 67.1983 131.838 63.431C131.838 63.431 128.168 53.7205 127.486 52.1616C127.486 52.1616 118.49 50.5702 120.341 56.3835Z",
    fill: "url(#paint2_linear_265_20130)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M128.135 123.577C128.07 119.031 128.037 114.224 128.07 110.587C128.102 104.871 129.369 99.2525 131.61 94.6733C135.085 87.6584 102.316 91.6205 103.745 97.3689C105.044 102.565 107.447 103.247 107.674 106.885C107.804 108.866 107.512 116.465 107.22 123.707C106.927 131.21 128.232 131.08 128.135 123.577Z",
    fill: "#FDBC9D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M131.607 95.3555C131.607 95.3555 136.641 84.4433 138.265 79.6368C139.856 74.8303 141.155 70.998 140.181 68.7571C139.207 66.5162 134.952 63.1387 129.723 62.9113C124.495 62.684 110.075 68.4324 108.484 69.4067C106.892 70.381 107.509 75.8046 108.159 76.1293C108.159 76.1293 103.969 82.852 103.677 92.465C103.417 100.974 104.392 101.299 111.666 103.864C118.616 106.268 127.515 103.734 131.607 95.3555Z",
    fill: "url(#paint3_linear_265_20130)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M130.539 56.0912C130.539 56.0912 130.117 63.983 131.545 67.2306C131.545 67.2306 133.981 73.2713 140.444 69.7638C140.444 69.7638 138.755 56.4484 138.495 55.4741",
    fill: "url(#paint4_linear_265_20130)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M111.832 60.4756C112.709 61.5798 114.95 68.0426 114.95 68.0426C113.813 70.8681 109.689 70.998 108.779 70.7057C107.87 70.4134 106.766 65.2172 106.766 65.2172C104.622 64.6001 104.07 60.3782 104.07 60.3782C104.07 60.3782 108.617 56.4485 111.832 60.4756Z",
    fill: "url(#paint5_linear_265_20130)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M102.281 130.657C102.281 130.657 106.178 133.905 116.246 133.905C126.314 133.905 131.185 130.43 131.185 130.43L131.673 112.308C131.673 112.308 128.815 116.173 120.403 116.27C112.024 116.368 104.879 116.757 103.256 112.665L102.281 130.657Z",
    fill: "#6C6CFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M103.582 112.47C103.582 114.614 109.753 116.367 117.385 116.367C125.017 116.367 131.187 114.614 131.187 112.47",
    stroke: "#6C6CFF",
    strokeWidth: 0.974298,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M117.709 145.759C152.864 145.759 181.363 140.743 181.363 134.555C181.363 128.366 152.864 123.35 117.709 123.35C82.5536 123.35 54.0547 128.366 54.0547 134.555C54.0547 140.743 82.5536 145.759 117.709 145.759Z",
    fill: "url(#paint6_linear_265_20130)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2121 110.976H58.668V114.029H77.2121V110.976Z",
    fill: "#E5F4FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5767 113.997C62.0699 113.997 64.091 111.976 64.091 109.483C64.091 106.989 62.0699 104.968 59.5767 104.968C57.0836 104.968 55.0625 106.989 55.0625 109.483C55.0625 111.976 57.0836 113.997 59.5767 113.997Z",
    fill: "url(#paint7_linear_265_20130)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3516 113.997C73.9792 113.997 77.7306 110.245 77.7306 105.618C77.7306 100.99 73.9792 97.2388 69.3516 97.2388C64.724 97.2388 60.9727 100.99 60.9727 105.618C60.9727 110.245 64.724 113.997 69.3516 113.997Z",
    fill: "url(#paint8_linear_265_20130)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M78.285 114.029C81.4238 114.029 83.9684 111.485 83.9684 108.346C83.9684 105.207 81.4238 102.663 78.285 102.663C75.1461 102.663 72.6016 105.207 72.6016 108.346C72.6016 111.485 75.1461 114.029 78.285 114.029Z",
    fill: "url(#paint9_linear_265_20130)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6331 42.0288H32.3594V50.2779H82.6331V42.0288Z",
    fill: "#E5F4FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0691 50.3107C38.8491 50.3107 44.3453 44.8144 44.3453 38.0345C44.3453 31.2546 38.8491 25.7584 32.0691 25.7584C25.2892 25.7584 19.793 31.2546 19.793 38.0345C19.793 44.8144 25.2892 50.3107 32.0691 50.3107Z",
    fill: "url(#paint10_linear_265_20130)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M58.602 50.3105C71.1754 50.3105 81.3681 40.1178 81.3681 27.5444C81.3681 14.971 71.1754 4.77832 58.602 4.77832C46.0287 4.77832 35.8359 14.971 35.8359 27.5444C35.8359 40.1178 46.0287 50.3105 58.602 50.3105Z",
    fill: "url(#paint11_linear_265_20130)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M82.765 50.3103C91.2668 50.3103 98.1589 43.4182 98.1589 34.9164C98.1589 26.4145 91.2668 19.5225 82.765 19.5225C74.2632 19.5225 67.3711 26.4145 67.3711 34.9164C67.3711 43.4182 74.2632 50.3103 82.765 50.3103Z",
    fill: "url(#paint12_linear_265_20130)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M135.247 73.9856C135.247 73.9856 132.325 72.3618 126.154 73.3361C119.983 74.3104 116.054 76.6162 112.481 76.4213C108.941 76.259 108.941 76.259 108.941 76.259C108.941 76.259 112.839 75.9342 113.813 75.9342C114.787 75.9342 118.457 74.6027 119.334 74.3104C120.308 73.9856 132.649 71.0627 135.247 73.9856Z",
    fill: "#D86964"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M105.075 77.9151C105.627 79.5064 107.381 80.3833 108.972 79.8312L141.449 68.6917C143.04 68.1396 143.917 66.3859 143.365 64.7945C142.813 63.2032 141.059 62.3263 139.468 62.8784L106.991 74.0179C105.367 74.57 104.523 76.2913 105.075 77.9151Z",
    fill: "url(#paint13_linear_265_20130)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M146.127 66.8732C147.813 66.8732 149.18 65.5064 149.18 63.8204C149.18 62.1344 147.813 60.7676 146.127 60.7676C144.441 60.7676 143.074 62.1344 143.074 63.8204C143.074 65.5064 144.441 66.8732 146.127 66.8732Z",
    fill: "url(#paint14_linear_265_20130)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M163.664 73.2384C172.005 73.2384 178.766 66.4772 178.766 58.1368C178.766 49.7964 172.005 43.0352 163.664 43.0352C155.324 43.0352 148.562 49.7964 148.562 58.1368C148.562 66.4772 155.324 73.2384 163.664 73.2384Z",
    stroke: "url(#paint15_linear_265_20130)",
    strokeWidth: 2.19727,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M103.778 77.2656C104.33 78.857 106.084 79.7339 107.675 79.1818L140.152 68.0423C141.743 67.4902 142.62 65.7365 142.068 64.1451C141.516 62.5537 139.762 61.6769 138.171 62.229L105.694 73.3684C104.07 73.9206 103.226 75.6418 103.778 77.2656Z",
    fill: "#6C6CFF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M144.826 66.2238C146.512 66.2238 147.879 64.857 147.879 63.171C147.879 61.485 146.512 60.1182 144.826 60.1182C143.14 60.1182 141.773 61.485 141.773 63.171C141.773 64.857 143.14 66.2238 144.826 66.2238Z",
    fill: "#FFCC00"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M162.367 72.589C170.708 72.589 177.469 65.8278 177.469 57.4874C177.469 49.147 170.708 42.3857 162.367 42.3857C154.027 42.3857 147.266 49.147 147.266 57.4874C147.266 65.8278 154.027 72.589 162.367 72.589Z",
    stroke: "#6C6CFF",
    strokeWidth: 2.19727,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M111.865 60.0205C111.865 60.0205 108.779 57.26 104.72 59.6957C100.66 62.1315 103.973 71.7445 103.973 71.7445C103.973 71.7445 105.012 75.1871 107.156 74.635C109.299 74.1153 109.949 71.1924 109.267 69.4062C108.585 67.62 109.267 65.7689 108.162 63.8527C108.162 63.8852 113.521 62.034 111.865 60.0205Z",
    fill: "url(#paint16_linear_265_20130)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M118.65 57.5203C118.65 57.5203 117.773 53.3633 112.447 55.052C107.121 56.7408 109.622 68.5298 109.622 68.5298C109.622 68.5298 109.849 72.7518 112.48 72.7518C115.11 72.7518 116.637 69.5691 116.344 67.3282C116.052 65.0873 117.156 62.3268 116.442 59.7936C116.409 59.7612 119.982 60.2808 118.65 57.5203Z",
    fill: "url(#paint17_linear_265_20130)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M138.592 56.7406C138.592 56.7406 139.21 52.5511 133.591 52.2913C128.005 52.0315 126.316 63.9829 126.316 63.9829C126.316 63.9829 125.082 68.0424 127.55 68.9193C130.019 69.7962 132.552 67.3929 133.039 65.152C133.526 62.9436 135.54 60.7352 135.702 58.1046C135.735 58.1046 138.917 59.8259 138.592 56.7406Z",
    fill: "url(#paint18_linear_265_20130)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M128.588 54.7599C128.588 54.7599 128.133 49.726 122.32 51.2849C115.11 53.201 116.474 66.1916 116.474 66.1916C116.474 66.1916 116.117 70.7059 118.91 71.0631C121.703 71.4203 123.781 68.2701 123.781 65.8344C123.781 63.3986 126.347 59.6638 125.892 56.8708C125.892 56.8708 129.627 57.9101 128.588 54.7599Z",
    fill: "url(#paint19_linear_265_20130)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M117.352 69.8938C117.352 69.8938 118.878 68.9519 120.697 69.6664C120.697 69.6664 121.119 65.1847 118.748 65.4445C116.41 65.7368 117.352 69.8938 117.352 69.8938Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M123.228 77.2336C126.277 77.2336 128.749 73.3078 128.749 68.465C128.749 63.6222 126.277 59.6963 123.228 59.6963C120.179 59.6963 117.707 63.6222 117.707 68.465C117.707 73.3078 120.179 77.2336 123.228 77.2336Z",
    fill: "url(#paint20_radial_265_20130)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M118.811 63.041C117.739 67.7826 119.298 72.1345 122.286 72.8165C125.274 73.4985 128.522 70.1859 129.593 65.4768C130.665 60.7352 129.106 56.3833 126.118 55.7013C123.163 55.0193 119.883 58.3319 118.811 63.041Z",
    fill: "url(#paint21_radial_265_20130)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M113.91 85.0928C114.657 82.7544 117.126 79.0196 119.042 77.3958C120.958 75.8044 121.607 74.8301 121.607 74.8301C121.607 74.8301 120.341 67.458 120.958 63.301C121.607 59.144 124.465 55.604 127.356 55.604C130.246 55.604 130.246 56.5783 130.246 57.5201C130.246 58.4944 129.597 62.9762 129.597 64.5675C129.597 66.1589 128.622 75.025 130.246 77.4932C131.837 79.929 132.487 86.9764 129.597 92.7572C126.706 98.5056 122.874 99.8046 118.392 99.1551C113.91 98.5381 111.669 92.1077 113.91 85.0928Z",
    fill: "#FDBC9D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M127.128 62.2943C126.478 62.2943 125.504 61.6447 125.504 60.0209C125.504 58.3971 125.504 58.2347 125.504 58.2347C125.504 58.2347 127.777 57.7476 128.427 57.7476C129.076 57.7476 129.758 57.7476 129.758 57.7476C129.758 57.7476 129.726 62.2943 127.128 62.2943Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M202.797 93.8936H170.516V99.1872H202.797V93.8936Z",
    fill: "#E5F4FF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M172.043 99.1552C176.384 99.1552 179.902 95.6364 179.902 91.2959C179.902 86.9553 176.384 83.4365 172.043 83.4365C167.702 83.4365 164.184 86.9553 164.184 91.2959C164.184 95.6364 167.702 99.1552 172.043 99.1552Z",
    fill: "url(#paint22_linear_265_20130)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M189.091 99.1874C197.162 99.1874 203.705 92.6443 203.705 84.573C203.705 76.5016 197.162 69.9585 189.091 69.9585C181.02 69.9585 174.477 76.5016 174.477 84.573C174.477 92.6443 181.02 99.1874 189.091 99.1874Z",
    fill: "url(#paint23_linear_265_20130)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M204.615 99.1549C210.068 99.1549 214.488 94.7347 214.488 89.2821C214.488 83.8294 210.068 79.4092 204.615 79.4092C199.162 79.4092 194.742 83.8294 194.742 89.2821C194.742 94.7347 199.162 99.1549 204.615 99.1549Z",
    fill: "url(#paint24_linear_265_20130)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M110.922 72.1023C110.922 72.1023 112.254 70.9331 114.17 71.3229C114.17 71.3229 113.813 66.8411 111.539 67.4906C109.266 68.1401 110.922 72.1023 110.922 72.1023Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M105.173 74.083C105.173 74.083 106.309 72.9138 108.096 73.1412C108.096 73.1412 107.478 69.0816 105.432 69.8286C103.419 70.5755 105.173 74.083 105.173 74.083Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M165.514 50.9922L159.961 64.3076",
    stroke: "#E5F4FF",
    strokeWidth: 1.87728,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M159.603 53.6875L157.395 59.0137",
    stroke: "#E5F4FF",
    strokeWidth: 1.87728,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M168.24 55.3115L165.188 62.6188",
    stroke: "#E5F4FF",
    strokeWidth: 1.87728,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_265_20130",
    x1: 54.0659,
    y1: 134.57,
    x2: 181.374,
    y2: 134.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3068,
    stopColor: "#6C6CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5728,
    stopColor: "#19194F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8572,
    stopColor: "#6C6CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_265_20130",
    x1: 114.675,
    y1: 66.3735,
    x2: 123.539,
    y2: 62.9618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49A89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_265_20130",
    x1: 124.234,
    y1: 57.5761,
    x2: 128.72,
    y2: 62.9453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49A89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_265_20130",
    x1: 117.097,
    y1: 93.6254,
    x2: 124.339,
    y2: 70.9111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49A89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_265_20130",
    x1: 135.606,
    y1: 59.0337,
    x2: 135.337,
    y2: 68.4607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49A89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_265_20130",
    x1: 104.082,
    y1: 64.7315,
    x2: 114.974,
    y2: 64.7315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2708,
    stopColor: "#F49A89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49A89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_265_20130",
    x1: 117.67,
    y1: 131.927,
    x2: 118.047,
    y2: 151.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C6CFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_265_20130",
    x1: 60.0417,
    y1: 108.667,
    x2: 64.0167,
    y2: 101.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_265_20130",
    x1: 69.4414,
    y1: 105.53,
    x2: 78.5999,
    y2: 96.7019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_265_20130",
    x1: 78.2708,
    y1: 108.339,
    x2: 88.9969,
    y2: 100.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_265_20130",
    x1: 33.3521,
    y1: 35.7966,
    x2: 44.1303,
    y2: 17.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_265_20130",
    x1: 58.8412,
    y1: 27.2921,
    x2: 83.675,
    y2: 3.35315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_265_20130",
    x1: 82.7767,
    y1: 34.9069,
    x2: 111.861,
    y2: 14.7713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_265_20130",
    x1: 104.897,
    y1: 71.3444,
    x2: 143.493,
    y2: 71.3444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F1048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_265_20130",
    x1: 143.046,
    y1: 63.8347,
    x2: 149.177,
    y2: 63.8347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C6CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_265_20130",
    x1: 147.458,
    y1: 58.1525,
    x2: 179.876,
    y2: 58.1525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F1048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8080FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_265_20130",
    x1: 107.473,
    y1: 62.0265,
    x2: 107.213,
    y2: 70.0973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49A89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_265_20130",
    x1: 113.89,
    y1: 60.3651,
    x2: 112.283,
    y2: 69.7493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49A89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_265_20130",
    x1: 137.307,
    y1: 50.4263,
    x2: 131.524,
    y2: 60.7349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49A89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_265_20130",
    x1: 125.031,
    y1: 51.3195,
    x2: 119.246,
    y2: 66.0761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBC9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49A89"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_265_20130",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(123.244 68.4801) scale(8.72979 6.93226)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E18388"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6901,
    stopColor: "#E18388",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_265_20130",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.209 64.254) rotate(12.6236) scale(8.72938 6.93216)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E18388"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6901,
    stopColor: "#E18388",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_265_20130",
    x1: 172.871,
    y1: 89.8697,
    x2: 179.794,
    y2: 77.9474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_265_20130",
    x1: 189.24,
    y1: 84.4073,
    x2: 205.19,
    y2: 69.0319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_265_20130",
    x1: 204.613,
    y1: 89.2982,
    x2: 223.294,
    y2: 76.3657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFilterScreen);
export default __webpack_public_path__ + "static/media/no_filter_screen.80e7861998d26e4fa84bba28e346c9fd.svg";
export { ForwardRef as ReactComponent };